import React, { forwardRef } from "react";
import BaseModal from "components/BaseModal";
import { Alert, Typography } from "antd";
import { MODAL_SIZE_EXTRA_LARGE } from "constants/Layout";
import { tokenGenerateSection } from "./AWSWebhookSuccessPopup";

const { Title, Paragraph } = Typography;
export default forwardRef(function LaceWorkWebhookSuccessPopup(
  { webhookTokenUrl, toolName, afterClose },
  ref
) {
  const { searchParams } = new URL(webhookTokenUrl);
  const token = searchParams.get("token");
  return (
    <BaseModal
      modalProps={{ footer: null, width: MODAL_SIZE_EXTRA_LARGE }}
      ref={ref}
      afterClose={afterClose}
    >
      <Title level={4}>
        Steps for creating Alert Channels and Rules in {toolName} Account
      </Title>
      <Alert
        message="Please save generated token, which will be required for further steps."
        type="info"
        description={<>Generated Token: {tokenGenerateSection(token)}</>}
      />
      <Title level={5}>For creating a Lacework channel</Title>
      <Paragraph>1. Login into your Lacework platform</Paragraph>
      <Paragraph>2. Go to Settings</Paragraph>
      <Paragraph>3. Navigate to Alert Channels.</Paragraph>
      <Paragraph>
        4. Click on the Add New button at the top right corner
      </Paragraph>
      <Paragraph>5. Select Webhook and click next</Paragraph>
      <Paragraph>6. Add the Name of the webhook</Paragraph>
      <Paragraph>
        7. Add the URL :- {webhookTokenUrl}
      </Paragraph>
      <Title level={5}>For creating a Lacework rule</Title>
      <Paragraph>1. Login into your Lacework platform</Paragraph>
      <Paragraph>2. Go to Settings</Paragraph>
      <Paragraph>3. Navigate to Alert Rules.</Paragraph>
      <Paragraph>
        4. Click on the Add New button at the top right corner
      </Paragraph>
      <Paragraph>
        5. Fill in the details and add the preferred Severity, Categories,
        SubCategories, Sources and Resource Groups. Add the webhook name to the
        Channel we had created earlier in the previous step.{" "}
      </Paragraph>
      <Paragraph>6. Click on Save.</Paragraph>
    </BaseModal>
  );
});
